<template>
  <div>
    <v-autocomplete
      outlined
      v-if="readonly === false"
      dense
      v-model="select"
      :items="Lista"
      item-text="Descripcion_provincia"
      item-value="id_provincia"
      label="Provincia"
      persistent-hint
      return-object
      @change="$emit('input', select.id_provincia)"
      hide-details
    ></v-autocomplete>
    <v-text-field
      outlined
      dense
      label="Provincia"
      v-if="readonly === true && !texto"
      readonly
      filled
      :value="select.Descripcion_provincia"
    ></v-text-field>
    <h3 v-if="texto">Prov: {{ select.Descripcion_provincia }}</h3>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
  props: {
    value: Number,
    readonly: {
      type: Boolean,
      default: false,
    },
    texto: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return {
      select: {
        id_provincia: 0,
        Descripcion_provincia: "",
      },
    };
  },
  computed: {
    ...mapState("provincias", ["Lista"]),
  },
  methods: {
    seleccionar(id) {
      if (id) {
        let pr = this.Lista.find((x) => x.id_provincia == id);
        if (pr) {
          this.select = pr;
        }
      }
    },
  },
  async mounted() {
    let id = this.value;
    this.seleccionar(id);
  },
  watch: {
    value: function(newVal, oldVal) {
      this.seleccionar(newVal);
    },
  },
};
</script>

<style></style>
